<div *ngIf="db">
    <table class="table facturas-table" style="margin: 15px 0;">
        <thead>
            <tr>
                <th colspan="7" class="text-2xl">Facturas</th>
            </tr>
            <tr>
                <th>Distribuidor</th>
                <th>Factura</th>
                <th>Fecha</th>
                <th>Producto</th>
                <th>Lote</th>
                <th>Cantidad</th>
                <th>Registrados</th>
                <!-- <th>Creado</th> -->
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let factura of db; trackBy: trackByFactura">
                <!-- fila encabezado de la factura -->
                <tr class="factura-header">
                    <td><a [routerLink]="['/facturas/empresa', factura.empresa?.id]">{{ factura.empresa ?
                            factura.empresa.nombre : ''}}</a></td>
                    <td>{{ factura.numero_factura }}</td>
                    <td>{{ factura.fecha | date:'dd/MM/YYYY'}}</td>
                    <td colspan="4">
                        Productos ({{ factura.productos.length }})
                    </td>
                </tr>
                <!-- filas de productos -->
                <tr *ngFor="let prod of factura.productos; trackBy: trackByProducto">
                    <td colspan="3"></td>
                    <td>{{ prod.tipo_producto.descripcion }}</td>
                    <td>{{ prod.lote }}</td>
                    <td>{{ prod.cantidad_productos }}</td>
                    <td>{{ prod.trazabilidad_productos.length }}</td>
                </tr>
            </ng-container>
            <ng-container *ngIf="db.length==0">
                <tr>
                    <td colspan="7" class="text-center p-4">
                        <div class="flex flex-column align-items-center">
                            <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                            <span class="text-600 mt-2">Sin registro de facturas</span>
                        </div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>